import newRequest from '@/utils/newOpenRequest'
// 导出列表
export function getExportList(data) {
	return newRequest({
		url: '/open/open/open-export/search',
		method: 'post',
		data,
	})
}



// WEBPACK FOOTER //
// ./src/api/export.js